import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { IRegistrationResponse, registration } from '@r1-frontend/api-domru/api-loyalty/v1/program/registration';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import Input from '@r1-frontend/ui-react/components/input';
import { FlexBoxCol } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';

import { POLICY_PAGE_LINK } from '~/src/constants';
import selectProviderId from '~/src/store/selectors/selectProviderId';

import PopupResponse from '../PopupResponse';

import * as ST from './styled';

const initPopupState = {
    title: '',
    text: '',
    type: 'success',
    isOpen: false,
};

type TField = {
    value: string,
    isValid: boolean,
    clearInput: () => void,
}

interface IProps {
    scrollRef: React.RefObject<HTMLDivElement>,
}

const FooterForm = ({ scrollRef }: IProps): JSX.Element => {
    const providerId = useSelector(selectProviderId);

    const [popupState, setPopupState] = useState<typeof initPopupState>(initPopupState);

    const emailInput = useRef() as React.MutableRefObject<any>;
    const [phone, setPhone] = useState<TField>();
    const [email, setEmail] = useState<string>();
    const [isValidInputs, setIsValidInputs] = useState<boolean>(false);

    useEffect(() => {
        const emailRef = emailInput?.current;
        const emailHasError = email ? emailRef.state.hasError : false;
        const isValid = !!(phone?.value && phone?.isValid && !emailHasError);
        setIsValidInputs(isValid);
    }, [phone, email]);

    const onSubmit = async() => {
        if (isValidInputs) {
            const resp = await doRequest.apiLoyalty<IRegistrationResponse>(
                registration(providerId, {
                    phone: phone?.value || '',
                    email,
                }),
            );
            if (resp.isSuccess) {
                setPopupState({
                    title: 'Спасибо за регистрацию!',
                    text: 'Получайте кешбэк бонусами и скидки от партнеров',
                    type: 'success',
                    isOpen: true,
                });
            } else {
                setPopupState({
                    title: 'Произошла ошибка',
                    text: '',
                    type: 'error',
                    isOpen: true,
                });
            }
        }
    };

    const buttonText = 'Зарегистрироваться';

    return (
        <>
            <ST.InfoBlock ref={scrollRef}>
                <ST.IconBlock/>
                <ST.FormText>
                    {'Проверьте информацию и актуализируйте данные.\nНомер телефона является обязательным для заполнения.'}
                </ST.FormText>
            </ST.InfoBlock>
            <ST.FormRow>
                <FlexBoxCol xs={12} sm={6} md={6}>
                    <ST.PhoneInput
                        required={true}
                        onChange={setPhone}
                        type='phone'
                        placeholder='Номер телефона'
                        errorMessage='Укажите корректный номер телефона'
                        aria-label='Телефон'
                        name='phone'
                        autoComplete='off'
                        className={'ym-disable-keys'}
                    />
                </FlexBoxCol>
                <FlexBoxCol xs={12} sm={6} md={6}>
                    <Input
                        ref={emailInput}
                        onChange={setEmail}
                        required={false}
                        type='email'
                        placeholder='Ваш e-mail'
                        errorMessage='Укажите корректный e-mail'
                        aria-label='E-mail'
                        name='e-mail'
                        autoComplete='off'
                        className={'ym-disable-keys'}
                    />
                </FlexBoxCol>
                <FlexBoxCol xs={12} sm={12} md={12}>
                    <ST.Button
                        type={btnTypes.ACCENT}
                        onClick={onSubmit}
                        disabled={!isValidInputs}
                    >
                        {buttonText}
                    </ST.Button>
                </FlexBoxCol>
                <FlexBoxCol xs={12} sm={12} md={12}>
                    <PolicyNote
                        data-test='agreement'
                        buttonText={buttonText}
                        agreeUrl={POLICY_PAGE_LINK}
                    />
                </FlexBoxCol>
            </ST.FormRow>
            <PopupResponse
                type={popupState.type}
                title={popupState.title}
                message={popupState.text}
                isOpen={popupState.isOpen}
                onClose={() => setPopupState(initPopupState)}
            />
        </>
    );
};

export default FooterForm;
